<template>
  <div class="sidebar" :class="{visible: active}">
    <div class="container">

      <img v-if="brand === 'pl'" src="../assets/pocketlegal.png" alt="PocketLegal">
      <img v-if="brand === 'ie'" src="../assets/immiexperts.png" alt="Immigration Experts">

      <!-- ADMIN MENU -->
      <ul v-if="isAdmin" class="menu">
        <li class="menu-item">
          <router-link to="/#">Home</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/userlist/admin/">Team</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/userlist/client/">Clients</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/visatypes/">Matter Types</router-link>
        </li>
        <li class="menu-item" :class="{activated: inEditor}">
          <router-link to="/docs/choosecategory/true/none">Document Editor</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/matters/">Matters</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/accounts/">Accounts</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/agreements/">Cost Agreements</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/pay/">Payment</router-link>
        </li>
        <li class="menu-item">
          <router-link to="/vevo/">VEVO</router-link>
        </li>
        <li class="menu-item mobileOnly" @click="logout">
          <a href="#">Logout</a>
        </li>
      </ul>

      <!-- CLIENT MENU -->
      <ul v-else class="menu">
        <li class="menu-item">
          <router-link to="/clienthome">
            Home
          </router-link>
        </li>
        <li v-for="(m, i) in matters" class="menu-item">
          <router-link :to="'/client-matter/' + i">
            Questions<!-- {{m.mattername}} -->
          </router-link>
        </li>
        <li class="menu-item">
          <router-link to="/documents">
            Documents
          </router-link>
        </li>
        <li class="menu-item">
          <router-link to="/invoices">
            Invoices
          </router-link>
        </li>
        <li v-if="agreement" class="menu-item">
          <button @click="viewAgreement" class="btn btn-link">Costs Agreement</button>
        </li>
        <li class="menu-item mobileOnly" @click="logout"><a href="#">
          Logout</a>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import utils from '@/components/utils'
import axios from 'axios'
import { bus } from '@/components/bus.js'

export default {
  name: 'sidebar',
  mixins: [utils],
  data () {
    return {
      inEditor: false // should the `Document Editor` link be active?
    }
  },
  created () {
    bus.$on('in_editor', (bool) => {
      this.inEditor = bool
    })
  },
  computed: {
    active () {
      return this.$root.$data.showSidebar
    },
    isAdmin () {
      return this.$root.$data.admin
    },
    matters () {
      return this.$root.$data.client.matters.map(m => { return m.matter })
    },
    agreement () {
      return this.$root.$data.user.agreement
    },
    brand () {
      return this.$root.$data.user.profile.brand || 'pl'
    }
  },
  methods: {
    setMatter (m) {
      this.$root.$data.client.matter = m
    },
    viewAgreement () {
      let a = this.agreement
      if (!a) return
      if (a.pdf) {
        window.open('/api/pdf/get/' + a.pdf, '_blank')
      } else {
        axios.post('/api/pdf/make/agreements/' + a._id)
        .then(res => {
          if (res.status === 200 && res.data) {
            a.pdf = res.data
            window.open('/api/pdf/get/' + a.pdf, '_blank')
          }
        }).catch(e => { console.log(e.response.data) })
      }
    },
    logout () {
      utils.methods.logout(this)
    }
  }
}
</script>

<style>
.sidebar {
  background-color: #136efb;
  background-image: linear-gradient(116deg, #136efb 25%, #3fa9f5 100%);
  width: 216px;
  position: fixed;
  height: 100%;
  top: 0px;
  left: -600px;
  transition:all .25s linear;
}
.visible {
  left: 0;
}
.sidebar img {
  width: 70%;
  margin: 12px 0 0 5%;
}
.menu {
  min-width: auto !important;
  box-shadow: none !important;
  background: none !important;
  margin: 2em 0 0 0 !important;
  padding: 0 !important
}
.menu .menu-item+.menu-item {
  margin-top: 0!important;
}
.menu .menu-item {
  color:inherit;
  padding: 0!important;
  position: relative;
}
.menu .menu-item>a:before {
  content: "";
  width: 10px;
  height: 10px;
  float: left;
  border-radius: 50%;
  position: absolute;
  top: 14px;
  left: 5%;
  border: 1px solid #fff
}
li.menu-item.activated a {
    background: #0258d7;
}
.menu .menu-item>a.router-link-exact-active.active:before {
  content: "";
  border: 1px solid #136efb
}
.menu .menu-item i{
  padding: 0 1.1em 0 0;
  font-size: 0.8em;
}
.menu .menu-item>a {
  padding: 0.3rem 0rem 0.3em 15%!important;
  color: #fff!important;
  margin: 0!important;
  border-radius: 0!important
}
.menu .menu-item>a.router-link-exact-active.active,
.menu .menu-item>a.active {
  background-color: #fff!important;
  color: #136efb !important;  
}
.menu .menu-item>a:hover,
.menu .menu-item>a:focus {
  background: #0358d8 !important;
  color: #fff !important;
}
.menu-item span {
  cursor: pointer;
}
.menu-item span:hover {
  color: #fff;
}
#username {
  margin-left: .8rem;
  color: white;
}
.mobileOnly {
  display: none
}
@media (max-width: 599px) { 
  .sidebar {
    width:100%;
    z-index: 999;
  }
  .main {
    width: 90%;
    margin: 5%;
  }
  .menu {
    padding: 0 !important;
  }
  .menu .menu-item {
    font-size: 1.3em;
  }
  .menu .menu-item>a:before {
    top: 18px;
  }
  .mobileOnly {
    display: block
  }
  .sidebar img {
    height: 26px;
    width: auto;
    margin: 13px 0 0 5%;
  }
}
@media print {
  .sidebar {
    display: none
  }
}
</style>



// WEBPACK FOOTER //
// sidebar.vue?5f443fec